{
  "name": "@docubook/flame",
  "version": "2.0.3",
  "description": "A blazing-fast React + MDX framework powered by Bun, built for modern documentation experiences.",
  "type": "module",
  "types": "./.docu/node/plugin.ts",
  "bin": {
    "flame": "./bin/cli.js"
  },
  "files": [
    "bin",
    "template",
    "docu.schema.json",
    ".docu",
    "!.docu/__tests__",
    "!.docu/dist",
    "!.docu/build-cache.json",
    "README.md",
    "LICENSE"
  ],
  "publishConfig": {
    "registry": "https://registry.npmjs.org/",
    "access": "public"
  },
  "engines": {
    "node": ">=20.11",
    "bun": ">=1.4.0"
  },
  "scripts": {
    "dev": "bun .docu/node/server.ts",
    "build": "NODE_ENV=production bun .docu/node/build.ts",
    "clean": "bun .docu/node/clean.ts",
    "preview": "bun .docu/node/preview.ts",
    "deploy": "bun .docu/node/deploy.ts",
    "compile:lib": "node bin/compile-lib.mjs",
    "test": "vitest run",
    "lint": "oxlint .",
    "prepublishOnly": "bun .docu/node/clean.ts && oxlint . && vitest run && node bin/compile-lib.mjs"
  },
  "keywords": [
    "docubook",
    "documentation",
    "static-site",
    "daisyui",
    "bun",
    "docs framework",
    "react",
    "react-dom"
  ],
  "homepage": "https://github.com/DocuBook/docubook/tree/main/packages/flame",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/DocuBook/docubook.git",
    "directory": "packages/flame"
  },
  "author": "wildan.nrs",
  "author-url": "https://wildan.dev",
  "license": "MIT",
  "dependencies": {
    "@docubook/core": "workspace:^",
    "@docubook/markdown": "workspace:^",
    "@docubook/themes-colors": "workspace:^",
    "@docubook/ui-react": "workspace:^",
    "@mdx-js/react": "^3.0.1",
    "@tailwindcss/cli": "4.3.0",
    "@tailwindcss/typography": "0.5.16",
    "bun-plugin-tailwind": "^0.1.2",
    "daisyui": "^5.5.19",
    "lucide-react": "^1.14.0",
    "react": "^19.2.7",
    "react-dom": "^19.2.7",
    "unified": "^11.0.0",
    "vite": "^8.2.1",
    "zod": "^4.4.3"
  },
  "peerDependencies": {
    "@sentry/bun": "^10.0.0"
  },
  "peerDependenciesMeta": {
    "@sentry/bun": {
      "optional": true
    }
  },
  "devDependencies": {
    "@types/node": "^22.0.0",
    "@types/react": "^19.0.0",
    "@types/react-dom": "^19.0.0",
    "bun-types": "^1.4.0",
    "tailwindcss": "^4.3.0",
    "typescript": "^7.0.2"
  }
}
